import { FC } from 'react';
import { IntlProvider } from 'react-intl';

import { PageSpinner } from '@app/components';
import { useLocaleConfig } from '@app/hooks';

export const LocalizationProvider: FC = ({ children }) => {
  const { locale, messages } = useLocaleConfig();

  if (locale && messages) {
    return (
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    );
  }

  return <PageSpinner />;
};
